<app-widget-option [categories]="['LAYERS']" [label]="'DONUT'" [limitedTo]="['gauge']">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.layer(current).gaugeDonut" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>